"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMobileDevice = void 0;
const ua_parser_js_1 = __importDefault(require("ua-parser-js"));
const isMobileDevice = () => {
    const parser = new ua_parser_js_1.default();
    const { type } = parser.getDevice();
    return type === 'mobile' || type === 'tablet';
};
exports.isMobileDevice = isMobileDevice;
